const houseResourceRouter = [
	{
		path: '/houseResource',
		name: 'HouseResource',
		component: () => import('@/views/houseResource')
	},
	{
		path: '/houseResource/regions',
		name: 'Regions',
		component: () => import('@/views/houseResource/Regions.vue')
	},
	{
		path: '/houseResource/maps',
		name: 'Maps',
		component: () => import('@/views/houseResource/Maps.vue')
	},
	{
		path: '/houseResource/sales',
		name: 'Sales',
		component: () => import('@/views/houseResource/Sales.vue')
	},
	{
		path: '/houseResource/building',
		name: 'Building',
		component: () => import('@/views/houseResource/Building.vue')
	},
	{
		path: '/houseResource/buildingView',
		name: 'BuildingView',
		component: () => import('@/views/houseResource/BuildingView.vue')
	},
	{
		path: '/houseResource/myHouse',
		name: 'MyHouse',
		component: () => import('@/views/houseResource/MyHouse.vue')
	},
	{
		path: '/houseResource/onlineSign',
		name: 'OnlineSign',
		component: () => import('@/views/houseResource/OnlineSign.vue')
	}
]
export default houseResourceRouter
